import { Link } from "react-router-dom";
import { Img, Text, Heading } from "../../components";
import VideoProfile from "../../components/VideoProfile";
import React, { Suspense } from "react";

const videoList = [
  {
    type: "Location",
    videoTitle: "How to get the best branch Location?",
    viewsText: "30K Views",
    videoTime: "1:05",
    thumbSrc:
      "https://ninja-content.s3.us-east-1.amazonaws.com/thumbnails/location.png",
    videoSrc:
      "https://ninja-content.s3.us-east-1.amazonaws.com/videos/Location_Final.mp4",
  },
  {
    type: "Financial",
    videoTitle: "How to Read a P&L",
    viewsText: "30K Views",
    videoTime: "2:21",
    thumbSrc:
      "https://ninja-content.s3.us-east-1.amazonaws.com/thumbnails/cost.png",
    videoSrc:
      "https://ninja-content.s3.us-east-1.amazonaws.com/videos/Cost+Structure_Final.mp4",
  },
];

export default function VideoGallerySection() {
  return (
    <>
      {/* video gallery section */}
      <div className="flex flex-col items-center">
        <div className="container-sm flex flex-col gap-2 lg:px-5 md:px-5">
          <div className="flex items-center justify-between gap-5">
            <Heading
              as="h1"
              className="sm:text-[18px] font-bold tracking-[0.15px] !text-gray-900_02"
            >
              Videos
            </Heading>
          </div>
          <div className="mr-[172px] flex gap-2 md:mr-0 md:flex-col sm:flex-row sm:overflow-x-scroll">
            <Suspense fallback={<div>Loading feed...</div>}>
              {videoList.map((d, index) => (
                <VideoProfile
                  {...d}
                  key={"listuserOne" + index}
                  className="rounded-[12px] bg-black-900_01"
                />
              ))}
            </Suspense>
          </div>
        </div>
      </div>
    </>
  );
}
